import React, { memo } from "react";
import { Grid } from "@mui/material";
import UpdateSection from "../../../../../common/updateSection/UpdateSection";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import EditMerchantInfo from "./EditMerchantInfo";
import EditTerminalInfo from "./EditTerminalInfo";
import TextInput from "../../../../../common/formElements/TextInput";
import EditCustomGroups from "./EditCustomGroups";

interface EditTerminalInformationProps {
  testOnly?: boolean;
  bulk: boolean;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

function EditTerminalInformationComponent({
  testOnly,
  bulk,
  isUpdateAllowed,
  shouldHideField,
}: EditTerminalInformationProps) {
  return bulk ? (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={12}>
        <UpdateSection name="sections.merchant" />
      </Grid>
      <Grid item xs={12}>
        <EditMerchantInfo isUpdateAllowed={isUpdateAllowed} />
      </Grid>
    </Grid>
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SectionWrapper isChild title="Terminal">
          <EditTerminalInfo
            isUpdateAllowed={isUpdateAllowed}
            testOnly={testOnly}
          />
        </SectionWrapper>
      </Grid>
      <Grid item xs={12}>
        <SectionWrapper isChild title="Merchant">
          <EditMerchantInfo isUpdateAllowed={isUpdateAllowed} />
        </SectionWrapper>
      </Grid>
      <Grid item xs={12}>
        <SectionWrapper isChild title="Note">
          <TextInput
            minRows={4}
            type="text"
            multiline
            fieldname="attributes.Note"
            style={{width: '100%'}}
            label="Note"
            disabled={!isUpdateAllowed}
          />
        </SectionWrapper>
      </Grid>
      <Grid item xs={12}>
        <SectionWrapper isChild title="Custom Groups">
          <EditCustomGroups isUpdateAllowed={isUpdateAllowed} />
        </SectionWrapper>
      </Grid>
    </Grid>
  );
}
export default memo(EditTerminalInformationComponent);
